if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* PK: Mobile product gallery.
   - Every slide is one full-width image, edge to edge, with no gap or neighbour showing.
   - Swiping snaps to exactly one image.
   - The slider height fits the image in view, so square and landscape images don't
     sit in a tall portrait box, and the page content moves up to meet them.
     The height switches instantly (no animation) as soon as the swipe lands.
   - The images are locked vertically: swiping up or down scrolls the page.
   - A row of long thin rectangles under the images replaces the arrows and 1/4
     counter. The active one is dark; tapping any of them jumps to that image.
   Styles are applied inline with !important so no other stylesheet can override them.
   Desktop is untouched. */
(function () {
  if (window.pkFitGalleryLoaded) return;
  window.pkFitGalleryLoaded = true;

  var mq = window.matchMedia('(max-width: 749px)');
  var SELECTOR = 'media-gallery .product__media-list';
  var LIST_PROPS = {
    'align-items': 'flex-start',
    'transition': 'none',
    'gap': '0',
    'column-gap': '0',
    'padding': '0',
    'margin-left': '0',
    'margin-right': '0',
    'width': '100%',
    'overflow-x': 'auto',
    'overflow-y': 'hidden',
    'overscroll-behavior-x': 'contain',
    'overscroll-behavior-y': 'auto',
    'touch-action': 'pan-x pan-y',
    'scroll-snap-type': 'x mandatory',
    'scroll-padding': '0',
    '-webkit-overflow-scrolling': 'touch'
  };
  var SLIDE_PROPS = {
    'flex': '0 0 100%',
    'width': '100%',
    'min-width': '100%',
    'max-width': '100%',
    'margin': '0',
    'padding': '0',
    'height': 'auto',
    'min-height': '0',
    'align-self': 'flex-start',
    'scroll-snap-align': 'start',
    'scroll-snap-stop': 'always'
  };
  var BOX_PROPS = ['aspect-ratio', 'height', 'min-height', 'max-height', 'width', 'padding-top'];

  function applyProps(el, props) {
    Object.keys(props).forEach(function (p) {
      el.style.setProperty(p, props[p], 'important');
    });
  }

  function clearProps(el, props) {
    (Array.isArray(props) ? props : Object.keys(props)).forEach(function (p) {
      el.style.removeProperty(p);
    });
  }

  function visibleSlides(list) {
    return Array.prototype.filter.call(list.children, function (slide) {
      return slide.offsetParent !== null;
    });
  }

  function currentIndex(list, n) {
    var w = list.clientWidth;
    if (!w) return 0;
    var idx = Math.round(list.scrollLeft / w);
    return Math.max(0, Math.min(n - 1, idx));
  }

  /* ---------- Pagination rectangles ---------- */

  function renderDots(bar, n) {
    while (bar.firstChild) bar.removeChild(bar.firstChild);
    for (var i = 0; i < n; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pk-gallery-dots__dot';
      b.setAttribute('data-index', String(i));
      b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + n);
      bar.appendChild(b);
    }
  }

  function updateDots(list) {
    var bar = list._pkDots;
    if (!bar) return;
    var n = visibleSlides(list).length;
    if (n < 2) {
      bar.style.display = 'none';
      return;
    }
    bar.style.display = '';
    if (bar.children.length !== n) renderDots(bar, n);
    var idx = currentIndex(list, n);
    Array.prototype.forEach.call(bar.children, function (dot, i) {
      var active = i === idx;
      if (dot.classList.contains('is-active') !== active) dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  function buildDots(list) {
    if (list._pkDots && list._pkDots.isConnected) return list._pkDots;
    var bar = document.createElement('div');
    bar.className = 'pk-gallery-dots';
    list.parentNode.insertBefore(bar, list.nextSibling);
    list._pkDots = bar;
    bar.addEventListener('click', function (e) {
      var dot = e.target.closest('.pk-gallery-dots__dot');
      if (!dot) return;
      var i = parseInt(dot.getAttribute('data-index'), 10) || 0;
      list.scrollTo({ left: i * list.clientWidth, behavior: 'smooth' });
    });
    return bar;
  }

  /* ---------- Layout ---------- */

  function prep(list) {
    var mobile = mq.matches;
    var viewer = list.closest('[id^="GalleryViewer"]');
    if (mobile) {
      applyProps(list, LIST_PROPS);
      buildDots(list);
      if (viewer) {
        applyProps(viewer, { padding: '0', margin: '0' });
        if (!viewer.classList.contains('pk-has-dots')) viewer.classList.add('pk-has-dots');
      }
    } else {
      clearProps(list, LIST_PROPS);
      list.style.removeProperty('height');
      if (viewer) {
        clearProps(viewer, ['padding', 'margin']);
        viewer.classList.remove('pk-has-dots');
      }
    }
    Array.prototype.forEach.call(list.children, function (slide) {
      var box = slide.querySelector('.product-media-container');
      var media = box ? box.querySelector('.media') : null;
      if (mobile) {
        applyProps(slide, SLIDE_PROPS);
        if (!box) return;
        var r = parseFloat(box.style.getPropertyValue('--ratio')) || 1;
        applyProps(box, {
          'aspect-ratio': String(r),
          'height': 'auto',
          'min-height': '0',
          'max-height': 'none',
          'width': '100%',
          'padding-top': '0'
        });
        if (media) media.style.setProperty('padding-top', '0', 'important');
      } else {
        clearProps(slide, SLIDE_PROPS);
        if (box) clearProps(box, BOX_PROPS);
        if (media) media.style.removeProperty('padding-top');
      }
    });
  }

  function currentSlide(list) {
    var listLeft = list.getBoundingClientRect().left;
    var best = null;
    var bestDist = Infinity;
    Array.prototype.forEach.call(list.children, function (slide) {
      if (slide.offsetParent === null) return;
      var dist = Math.abs(slide.getBoundingClientRect().left - listLeft);
      if (dist < bestDist) {
        bestDist = dist;
        best = slide;
      }
    });
    return best;
  }

  function fit(list) {
    if (!mq.matches) return;
    if (list.scrollTop !== 0) list.scrollTop = 0;
    var slide = currentSlide(list);
    if (!slide) return;
    var box = slide.querySelector('.product-media-container') || slide;
    var h = Math.round(box.getBoundingClientRect().height);
    if (h > 0 && list.style.getPropertyValue('height') !== h + 'px') {
      list.style.setProperty('height', h + 'px', 'important');
    }
  }

  function fitAll() {
    document.querySelectorAll(SELECTOR).forEach(function (list) {
      try {
        prep(list);
        fit(list);
        if (mq.matches) updateDots(list);
      } catch (err) {
        if (window.console) console.warn('PK gallery:', err);
      }
    });
  }

  /* Resize the moment the swipe lands on an image */
  var timers = typeof WeakMap === 'function' ? new WeakMap() : null;
  function settle(list, delay) {
    if (!timers || delay === 0) return fit(list);
    clearTimeout(timers.get(list));
    timers.set(list, setTimeout(function () { fit(list); }, delay));
  }

  function isSnapped(list) {
    var slide = currentSlide(list);
    if (!slide) return false;
    return Math.abs(slide.getBoundingClientRect().left - list.getBoundingClientRect().left) < 2;
  }

  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches(SELECTOR)) return;
      if (!mq.matches) return;
      if (t.scrollTop !== 0) t.scrollTop = 0;
      updateDots(t);
      if (isSnapped(t)) {
        fit(t);
      } else {
        settle(t, 40);
      }
    },
    true
  );
  document.addEventListener(
    'scrollend',
    function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches(SELECTOR)) return;
      if (!mq.matches) return;
      fit(t);
      updateDots(t);
    },
    true
  );

  window.addEventListener('resize', fitAll);
  window.addEventListener('load', fitAll);
  if (mq.addEventListener) mq.addEventListener('change', fitAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitAll);
  } else {
    fitAll();
  }

  /* Re-apply when the gallery is re-rendered (e.g. switching variant) */
  if ('MutationObserver' in window) {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(fitAll, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
